import React, { Fragment } from 'react';
import mixpanel from 'mixpanel-browser';
import PropTypes from 'prop-types';
import FooterLinkWrapper from './FooterLinkWrapper';
import { Mobile } from '../../MediaQuery';
import { TrackingEvents } from '../../../common/models';
import withCountryCode from '../../RoutesHoc/RoutesHoc';

const initTrackLinks = (code, link, linkId) => {
  let trackingEvent = TrackingEvents.italistMarketplacePageSelected();
  if (code === 'cc_section') {
    trackingEvent = TrackingEvents.italistCustomerServicePageSelected();
  }
  mixpanel.track_links(`#${linkId}`, trackingEvent, { page: link.title });
};

const FooterLinks = ({ code, links, buildUrlWithCountry }) => (
  <Fragment>
    {links.map((link, index) => {
      const linkId = `${code}-${index}`;
      const { title, url } = link;
      initTrackLinks(code, link, linkId);
      return (
        <a key={linkId} id={linkId} href={url.startsWith('http') ? url : buildUrlWithCountry(`${url}`)}>
          <FooterLinkWrapper>
            <Mobile> &bull; </Mobile>
            {title}
          </FooterLinkWrapper>
        </a>
      );
    })}
  </Fragment>
);

FooterLinks.propTypes = {
  code: PropTypes.string.isRequired,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired
    })
  ).isRequired
};

export default withCountryCode(FooterLinks);
